// Yellow "owner" tag rendered next to owner accounts in chat and on
// the leaderboard. Owners are identified by username OR Kinde email —
// keep this list in sync with snordeluxe-server's requireOwner
// middleware so a leak in one place doesn't expand admin access in
// the other.
//
// Username comparison is case-insensitive; same for email.

const OWNER_USERNAMES = new Set(['dev_person']);
const OWNER_EMAILS = new Set(['josh.fraese@gmail.com']);

// Accepts either a string (username, legacy callers) or a user object
// with optional .username and .email. The legacy single-arg shape is
// still supported so the chat/leaderboard renderers that pass just a
// username don't have to change.
export function isOwner(userOrUsername) {
    if (!userOrUsername) return false;
    if (typeof userOrUsername === 'string') {
        return OWNER_USERNAMES.has(userOrUsername.toLowerCase());
    }
    const uname = (userOrUsername.username || '').toLowerCase();
    const email = (userOrUsername.email || '').toLowerCase();
    if (uname && OWNER_USERNAMES.has(uname)) return true;
    if (email && OWNER_EMAILS.has(email)) return true;
    return false;
}

export function ownerBadgeHTML(username) {
    return isOwner(username)
        ? '<span class="owner-badge" title="Owner">OWNER</span>'
        : '';
}
